const SECOND_LEVEL_COMPONENTS_IN_TOP_LEVEL_DOMAINS = ['co', 'com', 'org', 'net', 'go', 'gov', 'edu', 'ac', 'or', 'ne']

export const getHostnameFromUrl = (url: string | undefined) => {
  if (!url) return undefined
  const lowercaseUrl = url.toLowerCase()
  const withoutSchema = lowercaseUrl.replace(/^(https?:\/\/)/, '')
  const hostname = withoutSchema.split('/')[0].split('?')[0]

  const parts = hostname.split('.')
  if (parts.length === 1) return undefined
  if (parts.length === 2) return hostname

  //Handles top-level domains like .co.uk
  const usesSecondLevelDomain =
    SECOND_LEVEL_COMPONENTS_IN_TOP_LEVEL_DOMAINS.includes(parts[parts.length - 2]) && parts[parts.length - 3] !== 'www'
  return parts.slice(usesSecondLevelDomain ? -3 : -2).join('.')
}
